import { FC, Suspense, lazy, useMemo } from "react";
import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import { HomePage } from "../pages/Homepage/HomePage";
import { MenuTestPage } from "../pages/MenuTestPage";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import { KEY_LOCALSTORAGE } from "../../app/modules/auth/core/_consts";
import { localStorageItem } from "../../app/modules/utils/LocalStorage";

import PendingScreen from "../modules/component/pending-screen";

const getMenusByPermission = () => {
  const menusEmr = localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.["oceantech-emr-server"] || [];
  const menusInpatient = localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.["oceantech-emr-inpatient-server"] || [];
  const menusOutpatient = localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.["oceantech-emr-outpatient-server"] || [];
  return [...menusEmr, ...menusInpatient, ...menusOutpatient];
};
const WizardsPage = lazy(() => import("../modules/wizards/WizardsPage"));
const PhanHeCDHAVaTDCN = lazy(() => import("../modules/phan-he-cdha-va-tdcn/PhanHeCDHAVaTDCN").then(m => ({default: m.PhanHeCDHAVaTDCN})));
const PhanHeKhamBenh = lazy(() => import("../modules/phan-he-kham-benh/PhanHeKhamBenh"));
const PhanHeQuanTriHeThong = lazy(() => import("../modules/phan-he-quan-tri-he-thong/PhanheQuanTriHeThong"));
const PhanHeVienPhiBaoHiem = lazy(() => import("../modules/phan-he-tiep-nhan-thanh-toan/tab-thanh-toan/ThanhToan").then(m => ({default: m.PhanHeVienPhiBaoHiem})));
const PhanHeXetNghiem = lazy(() => import("../modules/phan-he-xet-nghiem/PhanHeXetNghiem").then(m => ({default: m.PhanHeXetNghiem})));
const PhanHeTiepNhan = lazy(() => import("../modules/phan-he-tiep-nhan-thanh-toan/PhanHeTiepNhan"));
const NhaThuocVaThuNgan = lazy(() => import("../modules/nha-thuoc-va-thu-ngan/NhaThuocVaThuNgan"));
const PhanHeHanhChinh = lazy(() => import("../modules/phan-he-hanh-chinh/PhanHeHanhChinh"));
const PhanHeKhamDoan = lazy(() => import("../modules/phan-he-kham-doan/PhanHeKhamDoan"));
const PhanHeDieuTri = lazy(() => import("../modules/phan-he-dieu-tri/PhanHeDieuTri"));
const DatLichHen = lazy(() => import("../modules/dat-lich-hen/DatLichHen"));
const PhanHeVienPhi = lazy(() => import("../modules/phan-he-vien-phi/PhanHeVienPhi"));
const PhanHeChuyenKhoa = lazy(() => import("../modules/phan-he-chuyen-khoa/PhanHeChuyenKhoa").then(m => ({default: m.PhanHeChuyenKhoa})));
const ChamSocKhachHang = lazy(() => import("../modules/phan-he-cskh/ChamSocKhachHang"));
const DanhMuc = lazy(() => import("../modules/phan-he-danh-muc/DanhMuc"));
const PhanHeLayMau = lazy(() => import("../modules/phan-he-lay-mau"));
const PhanHeNoiTruDieuTri = lazy(() => import('../modules/phan-he-noi-tru-dieu-tri'));
const PhanHeBaoHiemYTe = lazy(() => import('../modules/phan-he-bao-hiem-y-te'));
const PhanHeNoiTru = lazy(() => import("../modules/phan-he-noi-tru/PhanHeNoiTru"));
const EinvoiceModule = lazy(() => import("../modules/einvoice/EinvoiceModule"));
const IntegrationModule = lazy(() => import("../modules/phan-he-tich-hop/IntegrationModule"));
const QuanLyLanKham = lazy(() => import("../modules/phan-he-qllk/QuanLyLanKham"));
const PrivateRoutes = () => {
  const navigate = useNavigate();

  const menusByPermission = useMemo(() => getMenusByPermission(), []);

  useEffect(() => {
    if (!menusByPermission?.length) {
      navigate("/error/403");
    }
  }, [menusByPermission?.length, navigate])
  return (
    <Routes >
      <Route index element={<Navigate to={`${menusByPermission?.[0]?.uri}`} />} />
      <Route path="/*" element={<Navigate to={`${menusByPermission?.[0]?.uri}`} />} />
      {/* <Route path="/*" element={<HomePage />} /> */}
      {/* <Route index element={<Navigate to="/home" />} */}
      <Route path="home" element={<HomePage />} />
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/home" />} />
        {/* Pages */}
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />
        <Route path="phan-he-tiep-nhan" element={<PhanHeTiepNhan />} />
        <Route path="fee-and-insurance" element={<PhanHeVienPhiBaoHiem />} />
        <Route path="cdha-tdcn" element={<PhanHeCDHAVaTDCN />} />
        <Route path="kham-benh" element={<PhanHeKhamBenh />} />
        <Route path="/test" element={<PhanHeXetNghiem />} />
        <Route path="phan-he-kham-doan" element={<PhanHeKhamDoan />} />
        <Route path="noi-tru" element={<PhanHeNoiTru />} />
        <Route path="dieu-tri-noi-tru" element={<PhanHeNoiTruDieuTri />} />
        <Route path="quan-tri-he-thong" element={<PhanHeQuanTriHeThong />} />
        <Route path="nha-thuoc-thu-ngan" element={<NhaThuocVaThuNgan />} />
        <Route path="chuyen-khoa" element={<PhanHeChuyenKhoa />} />
        <Route path="hanh-chinh" element={<PhanHeHanhChinh />} />
        <Route path="dieu-tri" element={<PhanHeDieuTri />} />
        <Route path="dat-lich-hen" element={<DatLichHen />} />
        <Route path="vien-phi" element={<PhanHeVienPhi />} />
        <Route path="cham-soc-khach-hang" element={<ChamSocKhachHang />} />
        <Route path="quan-ly-lan-kham" element={<QuanLyLanKham />} />
        <Route path="integration" element={<IntegrationModule />} />
        <Route path="einvoice" element={<EinvoiceModule />} />
        <Route path="lay-mau-xet-nghiem" element={<PhanHeLayMau />} />
        <Route path="system/emr/catalog" element={<DanhMuc />} />
        <Route path="insurance" element={<PhanHeBaoHiemYTe />} />

        {/* Lazy Modules */}
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route
          path="crafted/pages/wizards/*"
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
      <Route path="pending" element={<PendingScreen />} />
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--kt-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };

